import React from 'react';
import ReactMedia from 'react-media';
import { BREAKPOINTS } from '../utils/responsive';

export const IsMediumScreen = (props) => (
  <ReactMedia query={`(min-width: ${BREAKPOINTS.medium}px)`} {...props} />
);

export const IsLargeScreen = (props) => (
  <ReactMedia query={`(min-width: ${BREAKPOINTS.large}px)`} {...props} />
);
